import { usePost } from '../usePost';

const API_URL = import.meta.env.VITE_API_URL;

export function useSalvarPessoaTelefone() {
  return usePost({
    url: `${API_URL}/pessoas/salvar-telefone`,
    config: {
      timeout: 120000,
      getAccessToken: true,
    },
  });
}
